import {headers, baseURL} from 'src/services/auth';

/**
 * Returns all questionnaires
 * @param {AbortSignal} signal Optional abort signal to cancel the in flight request
 * @returns {Promise<any>} A promise returning the questionnaires information
 */
export function getQuestionnaires(merchantId, size = 25, signal = null) {
  const url = new URL(`${baseURL}/v2/api/questionnaire?merchant=${merchantId}&size=${size}`);

  return fetch(url.toString(), {
    method: 'GET',
    headers: headers,
    signal
  })
  .then(result => result.json())
  .then(result => result._embedded.questionnaire);
}
